<template>
	<div class="pr-move-area">
		<div class="btn-area">
			<a href="/visual-marketing" class="btn-back">Back to List</a>
		</div>
		<div class="item-wrap">
			<div class="item prev">
				<router-link
					:to="prevUrl"
					v-if="prevBoolean"
					:style="{ backgroundImage: 'url(' + prevBg + ')' }"
				>
					<dl>
						<dt>Previous</dt>
						<dd v-html="prevText"></dd>
					</dl>
				</router-link>
				<a href="javascript:;" class="is-disabled" v-else>
					<dl>
						<dt>Previous</dt>
						<dd>Coming Soon</dd>
					</dl>
				</a>
			</div>
			<div class="item next">
				<router-link
					:to="nextUrl"
					:style="{ backgroundImage: 'url(' + nextBg + ')' }"
					v-if="nextBoolean"
				>
					<dl>
						<dt>Next</dt>
						<dd v-html="nextText"></dd>
					</dl>
				</router-link>
				<a href="javascipt:;" class="is-disabled" v-else>
					<dl>
						<dt>Next</dt>
						<dd>다음 글이 없습니다.</dd>
					</dl>
				</a>
			</div>
		</div>
	</div>
</template>
<script>
import { store } from "../data/store.js";
export default {
	data() {
		return {
			store,
			ptStore: store.bsd,
			ptCurrent: {},
			currentUrl: "",
			prevUrl: "",
			nextUrl: "",
			prevBg: "",
			nextBg: "",
			prevText: "Coming Soon",
			nextText: "다음 글이 없습니다.",
			prevBoolean: false,
			nextBoolean: false,
		};
	},
	mounted: function () {
		var currentPath = this.$route.path.split("/");
		var currentUrl = currentPath[currentPath.length - 1];

		this.contentNav(currentUrl);

		$(".is-disabled").on("click", function (e) {
			e.preventDefault();
		});
	},
	methods: {
		contentNav(currentUrl) {
			this.prevContentSet(currentUrl);
			this.nextContentSet(currentUrl);
			this.currentUrl = currentUrl;
		},
		prevContentSet(currentUrl) {
			this.currentUrl = currentUrl;
			var allContentJson = this.ptCurrent;
			var pjIdx = allContentJson.findIndex((x) => x.ptUrl === currentUrl);

			if (pjIdx - 1 >= "0") {
				this.prevUrl = "/visual-marketing/" + allContentJson[pjIdx - 1].ptUrl;
				this.prevBg = allContentJson[pjIdx - 1].thumbImg;
				this.prevText = allContentJson[pjIdx - 1].thumbTitle;
				this.prevBoolean = true;
			} else {
				this.prevBoolean = false;
			}
		},
		nextContentSet(currentUrl) {
			this.currentUrl = currentUrl;
			var allContentJson = this.ptCurrent;
			var pjIdx = allContentJson.findIndex((x) => x.ptUrl === currentUrl);
			var pjLength = allContentJson.length;

			if (pjIdx < pjLength - 1) {
				this.nextUrl = "/visual-marketing/" + allContentJson[pjIdx + 1].ptUrl;
				this.nextBg = allContentJson[pjIdx + 1].thumbImg;
				this.nextText = allContentJson[pjIdx + 1].thumbTitle;
				this.nextBoolean = true;
			} else {
				this.nextBoolean = false;
			}
		},
	},
	watch: {
		$route(to, from) {
			if (to.path != from.path) {
				var currentPath = to.path.split("/");
				var currentUrl = currentPath[currentPath.length - 1];

				this.contentNav(currentUrl);
			}
		},
	},
	created() {
		this.ptCurrent = this.ptStore.slice().reverse();
	},
};
</script>

<style scoped>
.is-disabled {
	cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/ptMove.vue